<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="materialMatch">
        <div slot="toolbar">
          <el-upload
              :action="uploadUrl"
              :headers="uploadHeaders"
              :before-upload="beforeAvatarUpload"
              :disabled="disabled"
              :on-error="handlerError"
              :on-exceed="onExceed"
              :on-progress="onProgress"
              :on-success="handleSuccess"
              :show-file-list="false"
              accept=".xlsx"
              style="display: inline-block">
            <el-button :loading="importLoading" type="primary">导入</el-button>
          </el-upload>
        </div>
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="出厂编号">
              <el-input v-model.trim="filter.salesOrderNo" clearable/>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="salesOrderNo" align="center" label="出厂编号"/>
        <el-table-column prop="creatorName" align="center" label="创建人"/>
        <el-table-column prop="createTime" align="center" label="创建时间"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            width="120px">
          <template slot-scope="scope">
            <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </vm-table>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";
  import constant from "@/util/constant";
  import loginUtil from "@/util/loginUtil";


  export default {
    name: "PUI",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        disabled: false,
        importLoading: false,
        uploadUrl: window.config.basicServerHttpUrl + "materialMatch/importExcel",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        filter: {
          salesOrderNo:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },

      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","materialMatch",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style scoped>
</style>
